function handleDiscountAppliedEvent(e) {
  if (e.cart) {
    let docappTotalPrice = e.cart.total_price / 100;

    fetch('/cart.js')
      .then(resp => resp.json())
      .then(cartData => {
        if (typeof uspcountry === 'function') uspcountry(cartData, docappTotalPrice);
      })
      .catch(error => console.log(error));
  } else {
  }
}
document.body.addEventListener('docapp-discount-applied', handleDiscountAppliedEvent);
function load_cart(){
  fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = 'cart-drawer';
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.querySelector('.cart-sidebar');
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;

      document.querySelectorAll('.item-remove').forEach(function(cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener('click', (evt) => removeItem(data_line));
        initSizeVariantAddToCart();
      });

      document.querySelectorAll('.header-cart').forEach(function(cartButton) {
        cartButton.addEventListener('click', function(e) {
          document.querySelector('body').classList.add('open-drawer');
          initSizeVariantAddToCart();
          document.querySelector('body').classList.remove('open-menu', 'open-ac-drawer', 'open-search', 'open-sort', 'open-filter');
        });
      });

      document.querySelectorAll('.overlay-box,.cart-drawer-close,.drawer-close').forEach(function(cartButton) {
        cartButton.addEventListener('click', function(e) {
          document.querySelector('body').classList.remove('open-drawer', 'open-menu', 'open-search', 'open-sort', 'open-ac-drawer', 'open-filter');
        });
      });

      cartDraweJS();
      // productcarousel();
      drawerQuickBuy();
      const targetNode = document.querySelector('.drawer-footer-discount-code');
      if(targetNode){
        const observer = new MutationObserver((mutationsList) => {
          // if(document.querySelector('.drawer-middle')) document.querySelector('.drawer-middle').style.paddingBottom = (document.querySelector('.drawer-footer').offsetHeight - 34) + 'px';
          const drawerMiddle = document.querySelector('.drawer-middle');
          const drawerFooter = document.querySelector('.drawer-footer');
          
          if (drawerMiddle && drawerFooter) {
            drawerMiddle.style.paddingBottom = `${drawerFooter.offsetHeight}px`;
          }
        });
        observer.observe(targetNode, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true
        });
      }
      const url = '/cart.js';
      fetch(url)
        .then((resp) => resp.json())
        .then(function(data) {
          var cart_count = data.item_count;
          if (cart_count > 0) {
            document.querySelector('.cart-count').innerHTML = cart_count;
          } else {
            document.querySelector('.cart-count').innerHTML = '0';
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    });
}

load_cart();

function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
  function drawerQuickBuy(){
  // if(document.querySelector('.drawer-middle')) document.querySelector('.drawer-middle').style.paddingBottom = (document.querySelector('.drawer-footer').offsetHeight - 34) + 'px';
  const drawerMiddle = document.querySelector('.drawer-middle');
const drawerFooter = document.querySelector('.drawer-footer');

if (drawerMiddle && drawerFooter) {
  drawerMiddle.style.paddingBottom = `${drawerFooter.offsetHeight}px`;
}
  if(document.querySelector('.free-product-added')){
    let variant_id = document.querySelector('.free-product-added').getAttribute('data-id');
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        let productExists = cart.items.some(item => item.id == variant_id);
        if(!productExists){
          let formData = {
            'items': [{
              'id': variant_id,
              'quantity': 1
            }]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then((data) => {
            load_cart();
          })
          .catch((error) => {
            console.error(error);
          });
        }
      })
      .catch((error) => {
        console.error('Failed to fetch cart:', error);
      });
  }
  const freeProductEl = document.querySelector('.free-product-removed');
  const variantId = Number(document.querySelector('.free-product-removed')?.getAttribute('data-id'));
  if(freeProductEl && variantId){
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const matchingItem = cart.items.find(item => item.id === variantId);
        if(matchingItem){
          const updateData = {
            updates: {
              [variantId]: 0
            }
          };
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updateData),
          })
          .then(res => res.json())
          .then(data => {
            load_cart();
          })
          .catch(err => console.error("Error removing free product:", err));
        }
      })
      .catch(err => console.error("Failed to fetch cart:", err));
  }
  document.querySelectorAll('.cd-clt .quick_view_button').forEach((drawerQuickBtn) => {
    drawerQuickBtn.addEventListener('click',function(e){
      e.preventDefault();
      let url = drawerQuickBtn.getAttribute('data-url');
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.querySelector('body').classList.add('open-quick-buy');
        document.getElementById('quickView').getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
         document.querySelectorAll('.variant-list .variant').forEach(function(variant) {
        variant.addEventListener('click', function() {
          document.querySelectorAll('.variant-list .variant').forEach(function(v) {
            v.classList.remove('select');
          });
    
          this.classList.add('select');
    
          var variantId = this.getAttribute('data-id');
    
          var addToCartBtn = document.querySelector('.add-to-cart-btn');
          addToCartBtn.setAttribute('data-id', variantId);
    
          var wrapper = document.querySelector('.quick-btn-wrapper');
          wrapper.classList.add('variant-selected');
        });
              const closeBtn = document.querySelector('.quick-buy-close .close');
              const overlay = document.querySelector('.quick-overlay');
            
              if (closeBtn) {
                closeBtn.addEventListener('click', function () {
                  document.body.classList.remove('open-quick-buy');
                });
              }
            
              if (overlay) {
                overlay.addEventListener('click', function () {
                  document.body.classList.remove('open-quick-buy');
                });
              }

         // Remove existing event listener to prevent duplicates
         const existingBtn = document.querySelector(".add-to-cart-btn");
         if (existingBtn) {
           existingBtn.replaceWith(existingBtn.cloneNode(true));
         }
         
         document.querySelector(".add-to-cart-btn").addEventListener('click',function(e){
          e.preventDefault();
          let variant_id = this.dataset.id;
          let formData = {
            'items': [{
              'id': variant_id,
              'quantity': 1
            }]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then((data) => {
            const completeTheLookItem = data.items[0];

              window.dataLayer = window.dataLayer || []; // Safety check
              
              const trackingData = {
                event: 'complete_the_look_add_to_cart',
                ecommerce: {
                  currency: 'EUR', // or your store currency
                  value: completeTheLookItem.price / 100, // Convert cents to main currency unit
                  items: [completeTheLookItem] // Wrap in array for GA4 compatibility
                }
              };
              
              window.dataLayer.push(trackingData);
              console.log('Complete the Look Quick View item added to dataLayer:', trackingData);
            
            load_cart();
            document.body.classList.remove('open-quick-buy');
          })
          .catch((error) => {
            console.error(error);
          });
        });
      });
      })
      .catch((error) => {
        console.error(error);
      });
    });
  });
}
function cartDraweJS(){
  
   document.querySelectorAll('.variant-list .variant').forEach(function(variant) {
    variant.addEventListener('click', function() {
      document.querySelectorAll('.variant-list .variant').forEach(function(v) {
        v.classList.remove('select');
      });

      this.classList.add('select');

      var variantId = this.getAttribute('data-id');

      var addToCartBtn = document.querySelector('.add-to-cart-btn');
      addToCartBtn.setAttribute('data-id', variantId);

      var wrapper = document.querySelector('.quick-btn-wrapper');
      wrapper.classList.add('variant-selected');
    });
  });

  new Swiper(".usps",{
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    speed: 500,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  let nextbutton = document.querySelector('.cd-clt .swiper-button-next');
  let prevbutton = document.querySelector('.cd-clt .swiper-button-prev');
  new Swiper(".cd-clt-slider",{
    slidesPerView: "auto",
    loop: false,
    navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
    },
  });
  if(document.querySelectorAll(".product-cart-add-to")) document.querySelectorAll(".product-cart-add-to").forEach(function(event){
    event.addEventListener("click",function(){
      var VariantID = this.dataset.id;
      var ProQty = this.dataset.qty;
      const cartdrawer_parames = {
        id: VariantID, quantity: ProQty
      };
      changeVariant("/cart/add.js",cartdrawer_parames)
    })
  });
  if(document.querySelectorAll(".accorion-content-title")) document.querySelectorAll(".accorion-content-title").forEach(function(e){
    e.addEventListener("click",function(){
      this.classList.toggle("active");
      this.nextElementSibling.classList.toggle("active");
      var AddedHeight = this.parentElement.querySelector(".accordion-content.active");
      if(AddedHeight != null){
        var Height = this.nextElementSibling.querySelector("div").clientHeight + "px";
        AddedHeight.style.height = Height;
      }else{
        this.nextElementSibling.style.height = 0;
      }
    });
  })
  if(document.querySelectorAll(".cart-drawer-edit-btn")) document.querySelectorAll(".cart-drawer-edit-btn").forEach(function(e){
    e.addEventListener("click",function(){
      this.classList.toggle("active");
      this.parentElement.parentElement.querySelector(".cart-drawer-edit-options").classList.toggle("active");
    })
  });
  if(document.querySelectorAll(".product-select-variamnts li")) document.querySelectorAll(".product-select-variamnts li").forEach(function(e){
    e.addEventListener("click",function(){
      this.parentElement.querySelectorAll("li").forEach(function(evt){
        evt.classList.remove("active")
      })
      this.classList.add("active");
    })
  });
  // document.querySelector(".discount-button-label").addEventListener("click",function(){
  //   this.nextElementSibling.style.display="block";
  //   this.style.display="none";
  // })
  if(document.querySelectorAll(".Select-size-product")) document.querySelectorAll(".Select-size-product").forEach(function(e){
    e.addEventListener("click",function(){
      this.parentElement.parentElement.classList.remove("active");
      this.parentElement.parentElement.nextElementSibling.classList.add("active");
      this.parentElement.parentElement.parentElement.querySelector(".size-variant-selected").classList.add("active-save");
    });
  })
  function changeVariant(url,sendData, trackingInfo = null){
    fetch(url, {
      body: JSON.stringify(sendData),
      headers: { "Content-Type": "application/json" },
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
    })
    .then((response) => response.json())
    .then((data) => {
      // Track successful cart changes
      if (trackingInfo && data.items && data.items.length > 0) {
        window.dataLayer = window.dataLayer || [];
        
        // Find the specific item that was changed, or use the first item
        const changedItem = data.items.find(item => item.id == sendData.id) || data.items[0];
        
        const trackingData = {
          event: trackingInfo.event,
          ecommerce: {
            currency: 'EUR',
            value: changedItem.price / 100, // Use actual price from API response
            items: [changedItem] // Use actual item data from API response
          }
        };
        
        window.dataLayer.push(trackingData);
        console.log(`Cart change tracked: ${trackingInfo.event}`, trackingData);
      }
      
      load_cart();
    })
    .catch((err) => {
      console.log(err);
    });
  }
  var quanity_box = document.querySelectorAll('.quantity-box_cart_drawer');
  if(quanity_box){
    quanity_box.forEach(function(quantitywrap){
      var quantity_minus = quantitywrap.querySelector(".quantity-minus");
      var quantity_add = quantitywrap.querySelector(".quantity-plus");
      var quantity = quantitywrap.querySelector(".quantity-input input");
      var ProductID = quantitywrap.querySelector(".quantity-input input").dataset.variant;
      const minimum = 0;
      if(quantity_minus){
        quantity_minus.addEventListener("click", function(){
          if (quantity.value <= minimum) {
            quantity_minus.disabled = true;
            return;
          } else {
            quantity_minus.disabled = false;
          }
          if( quantity.value > 1){
            quantity.value--;
            setTimeout(function(){ 
              const dataTosendMinus = {
                id: ProductID, quantity: quantity.value
              };
              
              // Create tracking info for quantity decrease
              const trackingInfo = {
                event: 'cart_quantity_decrease'
              };
              
              changeVariant("/cart/change.js", dataTosendMinus, trackingInfo);
            }, 500);
          }
        });
      }
      if(quantity_add){
        quantity_add.addEventListener("click", function() {
          if (quantity.value > minimum) {
            quantity_minus.disabled = false;
          }
          quantity.value++;
          setTimeout(function(){ 
          const dataTosendPlus = {
            id: ProductID, quantity: quantity.value
          };
          
          // Create tracking info for quantity increase
          const trackingInfo = {
            event: 'cart_quantity_increase'
          };
          
          changeVariant("/cart/change.js", dataTosendPlus, trackingInfo);
          }, 500);
        });
      }
    });
  }
  if(document.querySelectorAll(".save-size-variant, .mobile-save-variant_main")) document.querySelectorAll(".save-size-variant, .mobile-save-variant_main").forEach(function (e) {
    e.addEventListener("click", function () {
      var Selected_size = this.parentElement.parentElement.querySelector(
        ".product-select-variamnts li.active"
      );
      if (Selected_size) {
        var getdata_id = Selected_size.dataset.id;
        var getdata_qty = this.parentElement.parentElement.querySelector(
          ".quantity-input input[type='text']"
        ).getAttribute("value");
        var getdata_current = Selected_size.dataset.current;
  
        const dataToSend = {
          id: getdata_id,
          quantity: getdata_qty,
        };
        const params = {
          id: getdata_current,
          quantity: 0,
        };
  
        if (getdata_id !== getdata_current) {
          setTimeout(function () {
            changeVariant("/cart/change.js", params);
          }, 1000);
  
          changeVariant("/cart/add.js", dataToSend);
          document.querySelector(".changed-size-message").style.display = "flex";
          setTimeout(function () {
            document.querySelector(".changed-size-message").style.display = "none";
          }, 3000);
        }

        if (getdata_id === getdata_current) {
          load_cart();
        }
      }
    });
  });
  if(document.querySelectorAll(".cd-plus")) document.querySelectorAll(".cd-plus").forEach((plus) =>{
    plus.addEventListener("click",(th) => {
      // var FindInput = this.parentElement.previousSibling.querySelector("input");
    })
  });
  if(document.querySelectorAll(".cd-minus")) document.querySelectorAll(".cd-minus").forEach((minus) =>{
    minus.addEventListener("click",(thi) => {
      // var FindInput = this.parentElement.nextSibling.querySelector("input");
    })
  });
  // $(document).on('click','.cd-plus', function () {
  //   var $qty = $(this).parents('.cd-qty-box').find(".cd-quantity-input");
  //   var currentVal = parseInt($qty.val(), 10);
  //   if (!isNaN(currentVal)) {
  //     $qty.val(currentVal+1);
  //     var input_qty = $qty.val();
  //     var data_line = $(this).closest('.item-row').data('line');
  //     displayLoading();
  //     changeItem(data_line,input_qty);
  //   }
  // });
  // $(document).on('click','.cd-minus', function () {
  //   var $qty = $(this).parents('.cd-qty-box').find(".cd-quantity-input");
  //   var currentVal = parseInt($qty.val(), 10);
  //   if (!isNaN(currentVal) && currentVal > 1) {
  //     $qty.val(currentVal - 1);
  //     var input_qty = $qty.val();
  //     var data_line = $(this).closest('.item-row').data('line');
  //     displayLoading();
  //     changeItem(data_line,input_qty);
  //   }
  // });
  if(window.innerWidth < 576){
    if(document.querySelectorAll(".cart-drawer-edit-btn")) document.querySelectorAll(".cart-drawer-edit-btn").forEach(function(e){
      e.addEventListener("click",function(){
        document.querySelector(".drawer-middle .cart-overlay").classList.add("active");
        document.querySelector(".drawer-footer").classList.add("down");
        this.classList.remove("active");
        // setTimeout(function(){ 
        //   this.classList.remove("active");
        // }, 2000);
      });
    })
    if(document.querySelectorAll(".cart-drawer-cancle-btn-mobile")) document.querySelectorAll(".cart-drawer-cancle-btn-mobile").forEach(function(e){
      e.addEventListener("click",function(){
        document.querySelector(".drawer-middle .cart-overlay").classList.remove("active");
        document.querySelector(".drawer-footer").classList.remove("down");
        this.parentElement.parentElement.classList.remove("active");
      });
    });
    document.body.addEventListener("click",function(e){
      var cart_overLsy = document.querySelector(".cart-overlay");
      if(e.target == cart_overLsy){
        if(document.querySelector(".size-variant-selected.active-save")){
        document.querySelector(".size-variant-selected.active-save").classList.remove("active-save");  
        }
        if(document.querySelector(".product-select-variamnts.active")){
          document.querySelector(".product-select-variamnts.active").classList.remove("active");
        }
        if(document.querySelector(".cart-drawer-edit-options.active")){
          document.querySelector(".cart-drawer-edit-options.active").classList.remove("active");
        }
        document.querySelector(".drawer-middle .cart-overlay").classList.remove("active");
        document.querySelector(".drawer-footer").classList.remove("down");
      }
    })
  }
  if(document.querySelectorAll('.cd-clt-slider .Product-size_variants .size_variant')){
    function quickAddButton(){
      // Remove existing event listeners by cloning elements
      document.querySelectorAll('.cd-clt-slider .Product-size_variants .size_variant').forEach(function(originalBtn){
        const newBtn = originalBtn.cloneNode(true);
        originalBtn.parentNode.replaceChild(newBtn, originalBtn);
      });
      
      document.querySelectorAll('.cd-clt-slider .Product-size_variants .size_variant').forEach(function(sizeList){
        sizeList.addEventListener('click',function(e){
          e.preventDefault();
          let variant_id = sizeList.dataset.id;
          let error_grid_outer = sizeList.closest('.snippet-product-grid');
          let error_grid = error_grid_outer.querySelector('.grid-error');
          let formData = {
            'items': [{
              'id': variant_id,
              'quantity': 1
            }]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then((data) => {
            if(data.status == 422)
            {
              error_grid.innerHTML = data.description;
              setTimeout(function(e){
                error_grid.innerHTML = '';
              },2000);
            }else{      
              
              const completeTheLookItem = data.items[0];

              window.dataLayer = window.dataLayer || []; // Safety check
              
              const trackingData = {
                event: 'complete_the_look_add_to_cart',
                ecommerce: {
                  currency: 'EUR', // or your store currency
                  value: completeTheLookItem.price / 100, // Convert cents to main currency unit
                  items: [completeTheLookItem] // Wrap in array for GA4 compatibility
                }
              };
              
              window.dataLayer.push(trackingData);
              console.log('Complete the Look Size Variant item added to dataLayer:', trackingData);

              if(document.location.href.indexOf('/cart') > -1) {
                window.location.href = "/cart";
              }else{
                if(typeof load_cart == 'function'){
                  load_cart();
                  setTimeout(function(e){
                    document.querySelector('body').classList.add('open-drawer');
                  },500);
                }else{
                  window.location.href = "/cart";
                }          
              }
              const url = '/cart.js';
              fetch(url)
              .then((resp) => resp.json())
              .then(function(data) {
                var cart_count = data.item_count;
                if(cart_count>0){
                  document.querySelector('.cart-count').innerHTML = cart_count;
                }else{
                  document.querySelector('.cart-count').innerHTML = '';
                }
              })
              .catch(function(error) {
                console.log(error);
              })
            }
          })
          .catch((error) => {
            console.error(error);
          });
        });
      });
    }
    quickAddButton();
  }
};
function productcarousel(){
  var productslider = [];
  document.querySelectorAll('.product-carousel').forEach(function(Element, index) {
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    if(!outer_carousel){
      return;
    }
    let nextbutton = outer_carousel.querySelector('.swiper-button-next');
    let prevbutton = outer_carousel.querySelector('.swiper-button-prev');
    if (!nextbutton || !prevbutton){
      return;
    }
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerView: "auto",
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      },
    };
    productslider[productid] = new Swiper(Element, swiperObject);
  });
}
// setTimeout(function(){ 
// cartDraweJS();
// }, 2000);



function initSizeVariantAddToCart() {
  const sizeVariants = document.querySelectorAll('.snippet-product-grid .product-variants .size_variant');
  if (!sizeVariants.length) return;

  sizeVariants.forEach(function (sizeList) {

    // 👇 Prevent duplicate event listener
    sizeList.removeEventListener('click', handleSizeVariantClick);
    sizeList.addEventListener('click', handleSizeVariantClick);
  });
}

function handleSizeVariantClick(e) {
  e.preventDefault();

  const sizeList = e.currentTarget;
  const variant_id = sizeList.dataset.id;
  const error_grid_outer = sizeList.closest('.snippet-product-grid');
  const error_grid = error_grid_outer.querySelector('.grid-error');

  const formData = {
    items: [{
      id: variant_id,
      quantity: 1
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == 422) {
        error_grid.innerHTML = data.description;
        setTimeout(() => {
          error_grid.innerHTML = '';
        }, 2000);
      } else {
        const completeTheLookItem = data.items[0];
        window.dataLayer = window.dataLayer || [];

        const trackingData = {
          event: 'complete_the_look_add_to_cart',
          ecommerce: {
            currency: 'EUR',
            value: completeTheLookItem.price / 100,
            items: [completeTheLookItem]
          }
        };
        initSizeVariantAddToCart();
        window.dataLayer.push(trackingData);
        console.log('Complete the Look Size Variant item added to dataLayer:', trackingData);

        if (document.location.href.indexOf('/cart') > -1) {
          window.location.href = "/cart";
        } else {
          if (typeof load_cart == 'function') {
            load_cart();
            setTimeout(() => {
              document.body.classList.add('open-drawer');
            }, 500);
          } else {
            window.location.href = "/cart";
          }
        }

        fetch('/cart.js')
          .then((resp) => resp.json())
          .then((data) => {
            const cart_count = data.item_count;
            const cartCountEl = document.querySelector('.cart-count');
            if (cartCountEl) {
              cartCountEl.innerHTML = cart_count > 0 ? cart_count : '';
            }
          })
          .catch((error) => console.log(error));
      }
    })
    .catch((error) => console.error(error));
}

initSizeVariantAddToCart();

// The dynamic-checkout button for each card is parked in an inert <template>
// (see snippets/product-grid.liquid) so the storefront does not instantiate a
// wallet button — and fetch the PayPal SDK — once per product on page load.
// Clone it in the first time a card's quick view is actually opened; the
// custom element upgrades on insertion.
function hydrateQuickPaymentButton(productGrid) {
  const holder = productGrid.querySelector('.quick-payment-button');
  if (!holder) return;
  const tpl = holder.querySelector('template.quick-payment-template');
  if (!tpl) return; // already hydrated
  const content = tpl.content.cloneNode(true);
  tpl.remove();
  holder.appendChild(content);
}

function initQuickView() {
  const quickViewBtns = document.querySelectorAll('.quick-view-btn');
  const closeBtns = document.querySelectorAll('.close-quick-view');

  quickViewBtns.forEach(function (btn) {
    if (btn.dataset.quickViewBound) return; // prevent double binding
    btn.dataset.quickViewBound = true;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const productGrid = btn.closest('.snippet-product-grid');
      if (productGrid) {
        productGrid.classList.add('active-quick');
        hydrateQuickPaymentButton(productGrid);
      }
      document.body.classList.add('overflow-hidden', 'overflow-hidden-swiper');
    });
  });

  closeBtns.forEach(function (closeBtn) {
    if (closeBtn.dataset.quickViewBound) return;
    closeBtn.dataset.quickViewBound = true;

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const productGrid = closeBtn.closest('.snippet-product-grid');
      if (productGrid) {
        productGrid.classList.remove('active-quick');
      }
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => {
        document.body.classList.remove('overflow-hidden-swiper');
      }, 200);
    });
  });
}


document.addEventListener('DOMContentLoaded', initQuickView);





function initQuickViewSizeSelection() {
  document.querySelectorAll('.quick-view').forEach(function (quickView) {
    const sizeVariants = quickView.querySelectorAll('.size_variant');
    const atcBtn = quickView.querySelector('.atc-btn');
    const btnWrapper = quickView.querySelector('.btn-wrapper');

    if (!sizeVariants.length || !atcBtn || !btnWrapper) return;

    sizeVariants.forEach(function (variant) {
      variant.addEventListener('click', function () {
        sizeVariants.forEach(function (v) {
          v.classList.remove('active');
        });

        this.classList.add('active');
        const selectedId = this.dataset.id;

        atcBtn.setAttribute('data-id', selectedId);
        btnWrapper.classList.add('selected');

        const hiddenVariantInput = quickView.querySelector('input[name="id"]');
        if (hiddenVariantInput) hiddenVariantInput.value = selectedId;
      });
    });
  });
}

initQuickViewSizeSelection();

function initAtcBtnAddToCart() {
  const atcBtns = document.querySelectorAll('.quick-view .atc-btn');
  if (!atcBtns.length) return;

  atcBtns.forEach(function (btn) {
    // 🔹 Remove any previously attached listener before adding new one
    btn.removeEventListener('click', handleAtcClick);
    btn.addEventListener('click', handleAtcClick);
  });
}

function handleAtcClick(e) {
  e.preventDefault();
  const btn = e.currentTarget;

  const variant_id = btn.getAttribute('data-id');
  const quickViewOuter = btn.closest('.quick-view');
  const errorGrid = quickViewOuter.querySelector('.grid-error');

  // If no variant selected
  if (!variant_id) {
    if (errorGrid) {
      errorGrid.innerHTML = 'Please select a size.';
      setTimeout(() => (errorGrid.innerHTML = ''), 2000);
    }
    return;
  }

  const formData = {
    items: [
      {
        id: variant_id,
        quantity: 1,
      },
    ],
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == 422) {
        if (errorGrid) {
          errorGrid.innerHTML = data.description;
          setTimeout(() => (errorGrid.innerHTML = ''), 2000);
        }
      } else {
        const addedItem = data.items[0];

        window.dataLayer = window.dataLayer || [];
        const trackingData = {
          event: 'quick_view_add_to_cart',
          ecommerce: {
            currency: 'EUR',
            value: addedItem.price / 100,
            items: [addedItem],
          },
        };
        window.dataLayer.push(trackingData);
        console.log('Quick View item added to dataLayer:', trackingData);
        initSizeVariantAddToCart();
        if (document.location.href.indexOf('/cart') > -1) {
          window.location.href = '/cart';
        } else {
          if (typeof load_cart == 'function') {
            load_cart();
            setTimeout(() => {
              document.querySelector('body').classList.add('open-drawer');
            }, 500);
          } else {
            window.location.href = '/cart';
          }
        }
        document.body.classList.remove('overflow-hidden-swiper');

        fetch('/cart.js')
          .then((resp) => resp.json())
          .then((cart) => {
            const cartCountEl = document.querySelector('.cart-count');
            if (cartCountEl) {
              cartCountEl.innerHTML = cart.item_count > 0 ? cart.item_count : '';
            }
          })
          .catch((error) => console.log(error));

        const productGrid = btn.closest('.snippet-product-grid');
        if (productGrid) productGrid.classList.remove('active-quick');
        document.body.classList.remove('overflow-hidden');
      }
    })
    .catch((error) => console.error(error));
}
initAtcBtnAddToCart();




// function initProductColorSwatches() {
//   const productCards = document.querySelectorAll('.snippet-product-grid');

//   productCards.forEach((card) => {
//     // Prevent duplicate event binding
//     if (card.dataset.swatchesInitialized === 'true') return;
//     card.dataset.swatchesInitialized = 'true';

//     const swatches = card.querySelectorAll('.product-color-swatch li');
//     const mainImg = card.querySelector('.main-product-image');
//     const secondImg = card.querySelector('.second-image');

//     if (!swatches.length || !mainImg) return;

//     const defaultMainSrc = mainImg.getAttribute('src');
//     const defaultMainSrcset = mainImg.getAttribute('srcset') || '';
//     const defaultSecondSrc = secondImg ? secondImg.getAttribute('src') : '';
//     const defaultSecondSrcset = secondImg ? secondImg.getAttribute('srcset') || '' : '';
//     const defaultActive = card.querySelector('.product-color-swatch li.active');

//     // Preload variant images
//     swatches.forEach((swatch) => {
//       const productLink = swatch.querySelector('a');
//       if (!productLink) return;
//       const href = productLink.getAttribute('href');

//       fetch(href + '.json')
//         .then(res => res.json())
//         .then(data => {
//           if (!data.product || !data.product.images.length) return;

//           swatch.dataset.mainImg = data.product.images[0].src;
//           if (data.product.images[1]) {
//             swatch.dataset.secondImg = data.product.images[1].src;
//           }

//           // Preload both images
//           const img1 = new Image();
//           img1.src = data.product.images[0].src;
//           if (data.product.images[1]) {
//             const img2 = new Image();
//             img2.src = data.product.images[1].src;
//           }
//         })
//         .catch(() => {});
//     });

//     // Hover interactions
//     swatches.forEach((swatch) => {
//       swatch.addEventListener('mouseenter', () => {
//         const mainSrc = swatch.dataset.mainImg;
//         const secondSrc = swatch.dataset.secondImg;

//         if (mainSrc) {
//           mainImg.src = mainSrc;
//           mainImg.setAttribute('srcset', `${mainSrc} 900w`);
//         }

//         if (secondImg && secondSrc) {
//           secondImg.src = secondSrc;
//           secondImg.setAttribute('srcset', `${secondSrc} 900w`);
//         }

//         swatches.forEach(s => s.classList.remove('active'));
//         swatch.classList.add('active');
//       });

//       swatch.addEventListener('mouseleave', () => {
//         mainImg.src = defaultMainSrc;
//         mainImg.setAttribute('srcset', defaultMainSrcset);
//         if (secondImg) {
//           secondImg.src = defaultSecondSrc;
//           secondImg.setAttribute('srcset', defaultSecondSrcset);
//         }

//         swatches.forEach(s => s.classList.remove('active'));
//         if (defaultActive) defaultActive.classList.add('active');
//       });
//     });
//   });
// }


// document.addEventListener('DOMContentLoaded', function () {
//   initProductColorSwatches();
// });





